module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"EmployeeBox":{"link":"Více informací o prodejně"}},"en":{"EmployeeBox":{"link":"More information about the store"}}}')
  delete Component.options._Ctor
}
